<script setup lang="ts">

import SkipButton from "@/components/loading/SkipButton.vue";

const props = withDefaults(
  defineProps<{
    canSkipLoader: boolean,
    medium: string,
  }>(),
  {
    canSkipLoader: false,
    medium: "something",
  },
);

const emit = defineEmits<{
  // change: [id: number],
  // update: [value: string],
  skip: [],
}>();
</script>

<template>
  <div
    class="metadata-loading"
  >
    <span
      class="metadata-spinner"
      :aria-label="`Loading ${props.medium}…`"
    />
    <span
      class="metadata-loading-text"
    >
      Loading {{ props.medium }}…
    </span>
    <SkipButton
      @skip="emit('skip')"
      :can-skip-loader="props.canSkipLoader"
    />
  </div>
</template>

<style lang="scss" scoped>
.metadata-loading {
  // position: absolute; // this would make it appear on the unscrolled 0x0 position - like all of those would stack there!
  inset: 0;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  color: rgba(255, 255, 255, 0.85);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.8);
}

.metadata-loading-text {
  font-size: 0.8rem;
}

.metadata-spinner {
  display: inline-block;
  width: 28px;
  height: 28px;
  border: 3px solid rgba(255, 255, 255, 0.15);
  border-top-color: var(--accent, #7f7);
  border-radius: 50%;
  animation: slide-spin 0.8s linear infinite;
}

@keyframes slide-spin {
  to {
    transform: rotate(360deg);
  }
}

img {
  opacity: 0;
  transition: opacity 0.3s;

}
</style>
